import { define } from "../preactement/define";
import { UsaBanner } from "../../UsaBanner";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = [
// Purposely leaving out `className` because it's unnecessary
'root-id'];
const Wrapper = _ref => {
  let {
    rootId,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(UsaBanner, {
    ...otherProps,
    id: rootId
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-usa-banner', () => Wrapper, {
  attributes
});